import {Section} from "../grouping/Section";
import {useUserMutations, useUsers} from "../../api/appuserapi";
import {Button, Col, Form, FormCheck, FormControl, FormGroup, FormLabel, FormSelect} from "react-bootstrap";
import {DataListView} from "../grouping/DataListView";
import {ModalPopUp} from "../grouping/ModalPopUp";
import React, {useCallback, useState} from "react";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {useForm} from "../../utilities/formutilities";
import {ButtonLoading} from "../ButtonLoading";
import {useClubs} from "../../api/clubapi";
import {LabelWithInput} from "../grouping/LabelWithInput";
import {FaCheck} from "react-icons/fa";

export function AccountsOption(props) {
    const {title} = props;
    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);
    const {users} = useUsers();
    return <Section title={title}>
        <DataListView
            onOpenChange={setOpen}
            onItemEditChange={setFileEditing}
            dataArray={users ? users : []}
            header={[{title: "Username", fieldName: "username"}, {
                title: "Lidnr",
                fieldName: "memberNumber"
            }, {title: "Rol", fieldName: "role"}, {title: "Sector control", fieldName: "sector"}]}
            searchHeaders={[{title: "Username", fieldName: "username"}, {
                title: "Lidnr",
                fieldName: "memberNumber"
            }, {title: "Rol", fieldName: "role"}, {title: "Sector control", fieldName: "sector"}]}/>

        <ModalPopUp open={open} onOpenChanged={setOpen}
                    modalContent={<AccountOptionModalContent onOpenChanged={setOpen} setFileEditing={setFileEditing}
                                                             fileEditing={fileEditing}/>}/>

    </Section>
}


const ROLE_IDS = [
    {id: 1, role: "ROLE_USER"},
    {id: 2, role: "ROLE_ADMIN"},
]


function AccountOptionModalContent(props) {
    const {fileEditing, onOpenChanged, setFileEditing} = props;

    const [isLoading, setIsLoading] = useState(false);
    const {clubs} = useClubs();
    const {editUser} = useUserMutations();
    const initialObjectInintializer = useCallback(() => fileEditing, [])
    const {tempObject, onChange, onSelectInputChanged} = useForm(initialObjectInintializer)
    const roleId = ROLE_IDS.filter(s => s?.role == fileEditing?.role) ? ROLE_IDS.filter(s => s?.role == fileEditing?.role)[0]?.id : 1;
    const sectors = clubs ? new Set(["ALL", ...clubs?.map(c => c?.sector)]) : ["ALL"];

    async function handleCreateSubmit(e) {
        e.preventDefault();
        //const result = editUser(tempObject);
        onOpenChanged(false)
        setIsLoading(false);
        setFileEditing(undefined);
    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        const result = await editUser(tempObject);
        setIsLoading(false);
        setFileEditing(undefined);
        onOpenChanged(false)
    }
console.log(tempObject.recieveSubmitEmail)
    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Form onSubmit={(event) => {
            fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
        }}>
            <Section title={fileEditing ? "Wijzig account" : "Nieuw bestand"}>

                <Col xs={6}>
                    <FormLabel>Gebruikersnaam</FormLabel>
                    <FormControl value={tempObject ? tempObject.username : ""}
                                 onChange={event => onChange(event, "title")}/>
                </Col>
                <Col xs={6}>
                    <FormLabel>Lidnr</FormLabel>
                    <FormControl value={tempObject ? tempObject.memberNumber : ""}
                                 onChange={event => onChange(event, "title")}/>
                </Col>
                <Col xs={6}>
                    <FormLabel>Rol</FormLabel>
                    <FormSelect defaultValue={tempObject.role} onChange={(e) => onChange(e, "role")}>
                        {ROLE_IDS?.map(ri => <option value={ri?.role}>{ri?.role}</option>)}
                    </FormSelect>
                </Col>
                <Col xs={6}>
                    <FormLabel>Sector control</FormLabel>
                    <FormSelect defaultValue={fileEditing?.sector ? fileEditing.sector : "BLO"}
                                onChange={(e) => onChange(e, "sector")}>
                        {Array?.from(sectors)?.map(s => <option value={s}>{s}</option>)}
                    </FormSelect>
                </Col>
                <Col xs={6}>
                    <FormLabel>Email</FormLabel>
                    <FormControl value={tempObject.email} onChange={e => onChange(e, 'email')}/>
                </Col>
                <Col xs={6} className={'p-1'}>
                    <Section>
                        <Col xs={12}>
                            <FormLabel htmlFor={'vzwjn'}>Ontvang Emails van formulieren?*</FormLabel>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={'ja'}> <FormCheck
                                                                     defaultChecked={tempObject.recieveSubmitEmail}
                                                                     id={'recieveEmail'} name={'recieveEmail'}
                                                                     value={'true'} type={'radio'}
                                                                     onChange={e => onChange(e, 'recieveSubmitEmail')}/></LabelWithInput>

                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={'nee'}> <FormCheck   defaultChecked={!tempObject.recieveSubmitEmail}
                                                                      id={'recieveEmail'} name={'recieveEmail'}
                                                                      value={'false'} type={'radio'}
                                                                      onChange={e => onChange(e, 'recieveSubmitEmail')}/></LabelWithInput>
                        </Col>
                    </Section>
                </Col>
                {fileEditing
                    ?
                    <Col xs={6}>

                    </Col>
                    :
                    ""
                }
                <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                    <ButtonLoading title={"Opslaan"} isLoading={isLoading} onClick={(e) => {
                        setIsLoading(true);
                        handleEditSubmit(e)
                    }}/>
                </Col>
            </Section>
        </Form>
    </ModalContentContainer>
}